export const RESET = 'EXCMREGION_UPDATE_RESET'
export const SET_ERROR = 'EXCMREGION_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMREGION_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMREGION_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMREGION_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMREGION_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMREGION_UPDATE_UPDATE_RETRIEVED'
